/* eslint-disable react/prop-types */
import Text from '../../../assets/styles/Text';
import Loader from '../../../components/Loader';
import * as styles from '../styles';

export default function FiltersSection({
  filters,
  selectedFilters,
  onFilterToggle,
  isLoading,
}) {
  const parseChoices = (choicesString) => {
    if (!choicesString) return [];
    return choicesString
      .split(',')
      .map((c) => c.trim())
      .filter(Boolean);
  };

  const organizeFiltersInColumns = () => {
    if (!filters || !filters.leftColumn || !filters.rightColumn) {
      return { leftColumn: [], rightColumn: [] };
    }
    return filters;
  };

  const renderFilter = (filter) => {
    const choices = parseChoices(filter.choices);
    const content = choices[0] === 'content';
    const isMultiple = filter.multiple || false; // ✅ Verifica se é múltiplo

    // Filtro com input (content)
    if (content) {
      return (
        <styles.FilterGroup key={filter.id}>
          <Text.Span>{filter.name}</Text.Span>
          <styles.FilterInput
            type="number"
            value={selectedFilters[filter.id] || ''}
            placeholder="Adicione sua informação"
            onChange={(e) => onFilterToggle(filter.id, e.target.value)}
          />
        </styles.FilterGroup>
      );
    }

    // Filtro com choices (único ou múltiplo)
    if (choices.length > 0) {
      return (
        <styles.FilterGroup key={filter.id}>
          <Text.Span>
            {filter.name}
            {isMultiple && <Text.Span> (selecione uma ou mais)</Text.Span>}
          </Text.Span>
          <styles.FilterButtonGroup $wrap={choices.length > 2}>
            {choices.map((choice) => {
              // ✅ Verifica se está ativo (array ou valor único)
              const isActive = isMultiple
                ? Array.isArray(selectedFilters[filter.id]) &&
                  selectedFilters[filter.id].includes(choice)
                : selectedFilters[filter.id] === choice;

              return (
                <styles.FilterButton
                  key={choice}
                  type="button"
                  $isActive={isActive}
                  onClick={() => onFilterToggle(filter.id, choice, isMultiple)}
                >
                  <Text.P>{choice}</Text.P>
                </styles.FilterButton>
              );
            })}
          </styles.FilterButtonGroup>
        </styles.FilterGroup>
      );
    }

    // Filtro booleano
    const isActive = selectedFilters[filter.id] === true;
    return (
      <styles.FilterGroup key={filter.id}>
        <Text.P>{filter.name}</Text.P>
        <styles.FilterButtonGroup>
          <styles.FilterButton
            type="button"
            $isActive={isActive}
            onClick={() => onFilterToggle(filter.id)}
          >
            <Text.P>Sim</Text.P>
          </styles.FilterButton>
          <styles.FilterButton
            type="button"
            $isActive={!isActive && selectedFilters[filter.id] === false}
            onClick={() => onFilterToggle(filter.id)}
          >
            <Text.P>Não</Text.P>
          </styles.FilterButton>
        </styles.FilterButtonGroup>
      </styles.FilterGroup>
    );
  };

  const { leftColumn, rightColumn } = organizeFiltersInColumns();

  if (isLoading) {
    return <Loader isLoading minimal />;
  }

  return (
    <styles.FiltersContainer>
      <Text.H1>INFORMAÇÕES SOBRE VOCÊ</Text.H1>

      <styles.FiltersRow>
        <styles.FiltersColumn>
          {leftColumn.map((filter) => renderFilter(filter))}
        </styles.FiltersColumn>

        <styles.VerticalDivider />

        <styles.FiltersColumn>
          {rightColumn.map((filter) => renderFilter(filter))}
        </styles.FiltersColumn>
      </styles.FiltersRow>
    </styles.FiltersContainer>
  );
}
